const PLATFORM_URLS = {
  main: import.meta.env.VITE_MOLOCHAIN_URL || 'https://molochain.com',
  admin: import.meta.env.VITE_ADMIN_URL || 'https://admin.molochain.com',
  auth: import.meta.env.VITE_AUTH_URL || 'https://auth.molochain.com',
  opt: import.meta.env.VITE_OPT_URL || 'https://opt.molochain.com',
  mololink: import.meta.env.VITE_MOLOLINK_URL || 'https://mololink.molochain.com',
  molo: import.meta.env.VITE_MOLO_URL || 'https://molo.molochain.com',
  app: import.meta.env.VITE_APP_URL || 'https://app.molochain.com',
} as const;

export default PLATFORM_URLS;
export type PlatformUrlKey = keyof typeof PLATFORM_URLS;
